module.exports = __webpack_public_path__ + "gxqgouche2212/static/img/download.371c44fa.jpg";